import React from "react"

export default props => (
  <div className="level">
    <a href="/learn">
      <div className="level-item ">
        <img className="header-icon" src="/icons.png" /> &nbsp;&nbsp;&nbsp;{" "}
        <span className="title is-4">
          <b>{props.text}</b>
        </span>
      </div>
    </a>
  </div>
)
